import React, { useState, useEffect } from "react";
import "./GameFunctionalRules.css";
import LessonProgress from "../progressbar/StatusProgres";
import FeedbackPopup from '../popuplessons/FeedbackPopup';
import ExplanationPopup from "../popuplessons/ExplanationPopup";
import CustomAlert from "../progressbar/CustomAlert";
import { useNavigate, useLocation } from "react-router-dom"; // 👈 ADĂUGAT useLocation



const GameFunctionalRules = () => {
  const location = useLocation(); // 👈 primește datele trimise de la LessonsGameFunctionalRules
  const navigate = useNavigate();

  const { chapterId, lessonId } = location.state || {}; // 👈 extragem datele

  const [transactions, setTransactions] = useState([]);
  const [current, setCurrent] = useState(0);

  const [isChecked, setIsChecked] = useState(false);
 
const [answers, setAnswers] = useState([]);

  const [showFeedback, setShowFeedback] = useState(false);
  const [answerStatus, setAnswerStatus] = useState(null);
  const [showExplanation, setShowExplanation] = useState(false);
  const [explanationText, setExplanationText] = useState("");
  const [continueAfterExplanation, setContinueAfterExplanation] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  // 🔁 Încarcă întrebările din API — dinamic după capitol și lecție
  useEffect(() => {
    if (!chapterId || !lessonId) {
      console.warn("Date lipsă — redirectăm la selectarea lecțiilor.");
      navigate("/LessonsGameFunctionalRules");
      return;
    }

    const fetchData = async () => {
      try {
        const res = await fetch(
          `https://contalearn.ro/api/functionalrules/${chapterId}/lesson/${lessonId}`
        );
        const data = await res.json();

        if (data.questions && Array.isArray(data.questions)) {
          setTransactions(data.questions);
        } else {
          console.error("Structura întrebărilor nu este validă:", data);
        }
      } catch (err) {
        console.error("Eroare la încărcarea datelor de pe server:", err);
      }
    };

    fetchData();
  }, [chapterId, lessonId, navigate]);

  // 🔁 Trecere automată după explicație
  useEffect(() => {
    if (!showExplanation && continueAfterExplanation) {
      handleNextQuestion();
      setContinueAfterExplanation(false);
    }
  }, [showExplanation, continueAfterExplanation]);

  // ✅ Verifică răspunsul
const handleCheckAnswer = () => {
  let isCorrect = false;

  if (question.quizType === "singleAccount") {
    isCorrect =
      answers[0].side === question.correctSide &&
      answers[0].variation === question.correctVariation;
  }

  if (question.quizType === "twoAccounts") {
    isCorrect = question.accounts.every((acc, index) =>
      answers[index].side === acc.correctSide &&
      answers[index].variation === acc.correctVariation
    );
  }

  setAnswerStatus(isCorrect ? "correct" : "incorrect");
  setIsChecked(true);
  setShowFeedback(true);
};


  // ✅ Următoarea întrebare
  const handleNextQuestion = () => {
    setCurrent((prev) => (prev + 1) % transactions.length);
  
    setIsChecked(false);
  
  
    setShowFeedback(false);
    setShowExplanation(false);
    setAnswerStatus(null);
  };

  const progress = transactions.length ? Math.round(((current + 1) / transactions.length) * 100) : 0;
  const question = transactions[current] || {};



  const canVerify =
  answers.length > 0 &&
  answers.every(a => a.side && a.variation);



  useEffect(() => {
  if (!question) return;

  if (question.quizType === "singleAccount") {
    setAnswers([{ side: null, variation: null }]);
  }

  if (question.quizType === "twoAccounts") {
    setAnswers(
      question.accounts.map(() => ({
        side: null,
        variation: null
      }))
    );
  }

  setIsChecked(false);
  setShowFeedback(false);
  setShowExplanation(false);
}, [current]);



const handleSelect = (index, side, variation) => {
  if (isChecked) return;

  const updated = [...answers];
  updated[index] = { side, variation };
  setAnswers(updated);
};



  if (transactions.length === 0) {
    return <p>Se încarcă exercițiile pentru lecția {lessonId}...</p>;
  }


   

  // ✅ Click pe X (ieșire)
  const handleExitClick = () => setShowAlert(true);

  const handleConfirmExit = () => {
    setShowAlert(false);
    navigate("/LessonsGameFunctionalRules");
  };

  const handleCancelExit = () => setShowAlert(false);

  return (
    <div className="game-container">
      <div className="game-accounts-rule">
        {/* 🔁 Bara de progres */}
        <LessonProgress percent={progress} onExitClick={handleExitClick} />

      

      <div>{question.imageoperation}</div>


        <div
  className="statement"
  dangerouslySetInnerHTML={{
    __html: question.statement || question.context
  }}
/>

        

       <div className={`accounts-wrapper ${question.quizType}`}>
  {(question.quizType === "singleAccount"
    ? [{ account: question.account }]
    : question.accounts
  ).map((acc, index) => (
    <div key={index} className="t-account">
      <div className="t-header">
        <div className="debit">D</div>
        <div className="tittle-account">
          {acc.account || question.account}
        </div>
        <div className="credit">C</div>
      </div>

      <div className="t-body">
  {/* Debit */}
  <div className="t-side-group">
    {["↑", "↓"].map(symbol => {
      const selected =
        answers[index]?.side === "D" &&
        answers[index]?.variation === symbol;

      const correct =
        isChecked &&
        (
          question.quizType === "singleAccount"
            ? question.correctSide === "D" &&
              question.correctVariation === symbol
            : question.accounts[index].correctSide === "D" &&
              question.accounts[index].correctVariation === symbol
        );

      const wrong = isChecked && selected && !correct;

      return (
        <div
          key={"D" + symbol}
          className={`t-option
            ${selected ? "selected" : ""}
            ${correct ? "correct" : ""}
            ${wrong ? "incorrect" : ""}
          `}
          onClick={() => handleSelect(index, "D", symbol)}
        >
          {symbol}
        </div>
      );
    })}
  </div>

  {/* LINIA DIN MIJLOC */}
  <div className="t-account-label"></div>

  {/* Credit */}
  <div className="t-side-group">
    {["↑", "↓"].map(symbol => {
      const selected =
        answers[index]?.side === "C" &&
        answers[index]?.variation === symbol;

      const correct =
        isChecked &&
        (
          question.quizType === "singleAccount"
            ? question.correctSide === "C" &&
              question.correctVariation === symbol
            : question.accounts[index].correctSide === "C" &&
              question.accounts[index].correctVariation === symbol
        );

      const wrong = isChecked && selected && !correct;

      return (
        <div
          key={"C" + symbol}
          className={`t-option
            ${selected ? "selected" : ""}
            ${correct ? "correct" : ""}
            ${wrong ? "incorrect" : ""}
          `}
          onClick={() => handleSelect(index, "C", symbol)}
        >
          {symbol}
        </div>
      );
    })}
  </div>
</div>

    </div>
  ))}
</div>


       


        

        <div className="game-bottom-buttons">
          {!isChecked ? (
            <button
              className={`game-verify-btn ${!canVerify ? "disabled" : ""}`}
              onClick={handleCheckAnswer}
              disabled={!canVerify}
            >
              Verifica
            </button>


          ) : (
            <button className="game-continue-btn" onClick={handleNextQuestion}>
              {current + 1 < transactions.length ? "Continua" : "Final"}
            </button>
          )}
        </div>
      </div>

      {/* ✅ Feedback */}
      {showFeedback && isChecked && (
        <FeedbackPopup
          status={answerStatus}
          onClose={() => setShowFeedback(false)}
          onContinue={handleNextQuestion}
          onShowAnswer={() => {
            setExplanationText(transactions[current]?.explanation || "Explicație indisponibilă.");
            setShowExplanation(true);
            setShowFeedback(false);
            setContinueAfterExplanation(true);
          }}
        />
      )}

      {/* ✅ Explicație */}
      {showExplanation && (
        <ExplanationPopup
          explanation={explanationText}
          onContinue={() => setShowExplanation(false)}
        />
      )}

      {/* ✅ Confirmare ieșire */}
      {showAlert && (
        <CustomAlert onConfirm={handleConfirmExit} onCancel={handleCancelExit} />
      )}
    </div>
  );
};

export default GameFunctionalRules;
